import React from 'react';
import Select from './Select';
import { useTranslation } from 'react-i18next';

const WarehouseSelect = ({
                           options = [],
                           value = null,
                           onChange = () => {},
                           isLoading = false
                         }) => {
  const { t } = useTranslation();

  const warehousesOptions = options.map(warehouse => ({
    key: warehouse.key,
    deleted: warehouse.deleted,
    searchLabel: warehouse.label,
    label: warehouse.deleted ?
      <div>
        <span>{warehouse.label}</span>
        {warehouse.deleted && <span className='text-info ms-1'> {t('filters.archive')}</span>}
      </div>
      : warehouse.label
  }));

  return (
    <Select
      placeholder='salesFilters.Warehouse'
      options={warehousesOptions}
      value={value}
      onChange={onChange}
      isLoading={isLoading}
      idKey="id"
      labelKey="label"
      returnObject={true}
      isSearchable
    />
  );
};

export default WarehouseSelect;